import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { selectIdentifierCollection } from 'store/buyerSlice';
import { IdentifierType } from '../models/Identifier';

const BLOCK_EMPLOYEE_EMAIL_DOMAINS = ['@squareup.com', '@block.xyz'];

/**
 * Returns true when the buyer has a verified email on a Block employee domain.
 * Used to expose not-yet-GA pages to Block employees only.
 */
const useIsBlockEmployee = (): boolean => {
  const emails = useSelector((state: AppState) =>
    selectIdentifierCollection(state, IdentifierType.Email)
  );

  return emails.some((email) =>
    BLOCK_EMPLOYEE_EMAIL_DOMAINS.some((domain) =>
      email.displayValue.endsWith(domain)
    )
  );
};

export default useIsBlockEmployee;
